import styled from 'styled-components';

export const Container = styled.div`
  font-size: 12px;
  padding: 12px;
  border-radius: 4px;
  color: #dc3545;
  border: 0.5px solid #dc3545;
  background-color: #dc354512;
  margin-bottom: 16px;
  font-weight: 500;
`;
